import { Commission } from 'containers/ProductRegist/hooks/types';
import { TaxPayerType } from 'containers/Settlement/graphQL/types';
import { ProductState } from 'types/api';

export type MeData = {
  me: {
    chatUser: ChatUser;
    user: UserDataType;
    host: MyInfoHost;
    issuedCoupons: {
      totalCount: number;
    };
  };
};

export enum SocialLinkProviderType {
  KakaoSync = 'KAKAO_SYNC',
  Facebook = 'FACEBOOK',
}

export enum HostBusinessInfoState {
  CANCELED = 'CANCELED',
  ENROLLED = 'ENROLLED',
  MODIFIED = 'MODIFIED',
  UNROLLED = 'UNROLLED',
  UNVERIFIED = 'UNVERIFIED',
  INSPECTING = 'INSPECTING',
}

type NoticeMediaChannel = 'EMAIL' | 'SMS' | 'PUSH';

type NoticeReceiveAgreement = {
  id: number;
  channel: NoticeMediaChannel;
  advertised: boolean;
  agreed: boolean;
  agreedAt: Date;
  updatedAt: Date;
};

export type UserDataType = {
  id: number;
  email?: string;
  mobileNumber?: string;
  nickname?: string;
  birth?: string;
  gender?: string;
  noticeReceiveAgreements: NoticeReceiveAgreement[];
  socialLinks: {
    id: number;
    socialUserId: string;
    provider: SocialLinkProviderType;
  }[];
  privateProfile: boolean;
  joinedAt: string; // Date String
  certificated: boolean;
  verified: boolean;
  invitationCode?: string;
  profileImage: {
    thumbnail: string;
  } | null;
  usablePoint: {
    availables: number;
  };
};

export type ChatUser = {
  token: string;
  userId: string;
  userNickName: string;
};

export type MyInfoHost = {
  id: string;
  name: string;
  description: string;
  phoneNumber: string;
  createdAt: number;
  profileImage: {
    thumbnail: string;
  } | null;
  super: boolean;
  settlement: HostData | null;
  commission: HostCommission;
  wishInfo: { count: number; isWishedByMe: boolean };
  personalInfo: {
    email: string;
    name: string;
    phoneNumber: string;
    notificationPhoneNumber?: string | null;
  };
  productReviewInfo: { count: number };
  productInfo: { counts: { count: number; status: ProductState }[] };
};

export interface HostCommission {
  absent: Commission;
}

export interface HostData {
  attachments?: AttachmentsEntity[] | null;
  businessInfo: BusinessInfo;
  bankAccount: BankAccount;
  tossSellerInfo: TossSellerInfo | null;
}
export interface AttachmentsEntity {
  createdAt: number;
  fileKey: string;
  id: string;
}
export interface BusinessInfo {
  address: string;
  businessItem: string;
  businessType: string;
  representativeName: string;
  taxPayerName: string;
  taxPayerType: string;
  isRegister: boolean;
  status: HostBusinessInfoState;
}
export interface BankAccount {
  account: Account;
  verified: boolean;
  verifiedAt: number;
}
export interface Account {
  accountNo: string;
  bank: Bank;
  holder: string;
}
export interface Bank {
  code: string;
  name: string;
}
export interface TossSellerInfo {
  businessType: TaxPayerType;
  createdAt: number;
  hostId: string;
  isActive: boolean;
  refSellerId: string;
  registrationNo: string;
  status: TossPaymentsSellerState;
  tossSellerId: string;
  updatedAt: number;
}

export enum TossPaymentsSellerState {
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  FAILED = 'FAILED',
  KYC_REQUIRED = 'KYC_REQUIRED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
}
